export default {
      id: "trust-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#trust",
      toString: function () {
        return this.url;
      }
    }